<template>
  <div id="wpcal_admin_other_app" class="wpcal_admin_end">
    <component
      :is="dynamic_component"
      @change-dynamic-component="load_component($event)"
    />
  </div>
</template>

<script>
import DeactivateFeedback from "@/admin_other/DeactivateFeedback.vue";

export default {
  components: {
    DeactivateFeedback
  },
  data() {
    return {
      dynamic_component: null
    };
  },
  methods: {
    load_component(component) {
      this.dynamic_component = component;
    }
  }
};
</script>

<style src="@/assets/fonts/wf-stylesheet.css"></style>
<style src="@/assets/css/admin_other_app.css"></style>
<style>
.wpcal_admin_end {
  color: #131336;
}
</style>
